var _path, _path2, _path3, _path4, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 35,
    viewBox: "0 0 57 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3964 34.7927C27.0041 34.7927 34.7927 27.0041 34.7927 17.3964C34.7927 7.78862 27.0041 0 17.3964 0C7.78862 0 0 7.78862 0 17.3964C0 27.0041 7.78862 34.7927 17.3964 34.7927Z",
    fill: "#FF6041"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.285 34.7927C48.8928 34.7927 56.6814 27.0041 56.6814 17.3964C56.6814 7.78862 48.8928 0 39.285 0C29.6773 0 21.8887 7.78862 21.8887 17.3964C21.8887 27.0041 29.6773 34.7927 39.285 34.7927Z",
    fill: "#FFD941"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3945 3.91797C32.3146 7.10451 34.8203 11.9621 34.8203 17.4068C34.8203 22.8516 32.3146 27.7092 28.3945 30.8957C24.4745 27.7092 21.9688 22.8516 21.9688 17.4068C21.9688 11.9621 24.4745 7.10451 28.3945 3.91797Z",
    fill: "#FFD941"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1414_18625",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 3,
    width: 14,
    height: 28
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3955 3.91797C32.3155 7.10451 34.8213 11.9621 34.8213 17.4068C34.8213 22.8516 32.3155 27.7092 28.3955 30.8957C24.4755 27.7092 21.9697 22.8516 21.9697 17.4068C21.9697 11.9621 24.4755 7.10451 28.3955 3.91797Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1414_18625)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7852 7.34766H39.527V9.60584H18.7852V7.34766Z",
    fill: "#FF6041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7852 11.8008H39.527V14.059H18.7852V11.8008Z",
    fill: "#FF6041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7852 16.293H39.527V18.5512H18.7852V16.293Z",
    fill: "#FF6041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7852 20.7422H39.527V23.0004H18.7852V20.7422Z",
    fill: "#FF6041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7852 25.1523H39.527V27.4105H18.7852V25.1523Z",
    fill: "#FF6041"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.2212fc63b75b3b80d06f015d1a4a4454.svg";
export { ForwardRef as ReactComponent };